import React from 'react';
import { message, Divider, Popconfirm } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import DepartmentAdd from './components/DepartmentAdd';
import { postFrom, config } from '../../axios';
import { dicDepartmentStatus } from '../../axios/dictionaries';

export default class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, //页面加载中
            params: {
                name: '', //部门id
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            createOrEdit: false, //默认为创建
            optionData: [], //部门信息
        }
        this.handleNewAdd = this.handleNewAdd.bind(this)
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            optionData,
            createOrEdit,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="g-3-2" type="primary" icon="plus" onClick={this.handleNewAdd}>新增</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                        showCancel={false}
                    />
                </div>

                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleDelete: this.handleDelete })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <DepartmentAdd
                    onRef={ref => this.departmentAddRef = ref}
                    visible={showAddModal}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    optionData={optionData}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                />
            </PageWrap>
        )
    }


    componentDidMount() {
        this.handleSearch();
    }

    handleNewAdd() { //新增
        this.setState({ showAddModal: true, createOrEdit: false })
        this.departmentAddRef.initPack(); //true: 密码类型
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true })
        this.departmentAddRef.loadPack({ id })
        this.departmentAddRef.initPack();
    }

    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { departmentId: id };
        postFrom({
            url: config.API_department_deleteDepartment,
            data,
        }).then(res => {
            this.setState({ loading: false });
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_department_findDepartmentPageList,
            data,
        }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

}

const searchData = (optionData) => [
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在部门名称内模糊查询'
    },
];
const columns = ({ current, handleEdit, handleDelete }) => [

    {
        title: '部门',
        dataIndex: 'name'
    },
    {
        title: '部门负责人',
        dataIndex: 'departmentHeadName'
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {

            let now = dicDepartmentStatus.find(item => parseInt(item.value) === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                <AuthButton authkey="g-3-3"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>
                <Divider type="vertical" />
                <AuthButton authkey="g-3-4">
                    <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </AuthButton>
            </div>)
        }

    },
];



// WEBPACK FOOTER //
// ./src/page/Employee/Department.js